<template>
  <div class="basic-details-screen mb-20">
    <div v-if="this.site" class="row">
      <div class="col-sm-12 button-row" v-if="loggedInUser.role === 'admin'">
        <base-button :title="$t('app.partners.update_partner')"
        classNames="btn btn-orange rounded pull-right"
        @clicked="clickUpdateSite"/>
      </div>
      <div class="details-part col-sm-5" v-if="site">
        <div class="card-list">
          <card-display v-for="(item, index) in mappedSite" :key="index" :title="item.title" :value="item.value" />
        </div>
      </div>
      {{  }}
      <div class="contact-part col-sm-7">
        <site-canvas v-if="this.site.map_url" ref="siteCanvasRef" :locations="locations"
          :imageUrl="this.site.map_url" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseButton from '@/components/shared/buttons/BaseButton';
import SiteCanvas from '@/components/modules/partners/SiteLocations';
import GenericForm from '@/components/shared/forms/GenericForm';
import CardDisplay from './CardDisplay';

export default {
  name: 'BasicDetailsScreen',
  components: {
    'card-display': CardDisplay,
    'base-button': BaseButton,
    'site-canvas': SiteCanvas,

  },
  props: {
  },
  data() {
    return {
      isLoading: true,
      site: undefined,
      locations: [],
      users: [],
      siteAttributes: [
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'contact',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'contact_email',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'contact_phone',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'post_code',
          type: 'text',
          classes: 'col-md-4',
        },
        {
          name: 'city',
          type: 'text',
          classes: 'col-md-4',
        },
        {
          name: 'address',
          type: 'text',
          classes: 'col-md-4',
        },
        {
          name: 'land_register_reference',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'eov_x',
          type: 'number',
          classes: 'col-md-6',
        },
        {
          name: 'eov_y',
          type: 'number',
          classes: 'col-md-6',
        },
        {
          name: 'file',
          type: 'file',
          multiple: false,
        },
      ],
    };
  },
  created() {
    this.fetchSite({
      partnerId: this.loggedInUser.partner_id,
      id: this.$route.params.id,
    }).then((response) => {
      this.site = response;
      this.users = response.users;
      this.locations = this.site.locations
    });
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    leadList() {
      const result = [];
      if (this.users.length === 1) {
        result.push(this.users);
      }
      this.users.forEach((user, index) => {
        let userList = [];
        if (index === 0 || index % 2 !== 0) {
          userList.push(user);
        } else if (index % 2 !== 0 && index === this.users.length - 1) {
          result.push(userList);
        } else {
          result.push(userList);
          userList = [];
          userList.push(user);
        }
      });
      return result;
    },
    mappedSite() {
      const mappedSite = [];
      const attributes = ['name', 'contact', 'contact_phone', 'contact_email', 'post_code', 'city', 'address', 'land_register_reference', 'eov_x', 'eov_y'];
      Object.keys(this.site).forEach((element) => {
        if (attributes.includes(element)) {
          mappedSite.push({
            title: element,
            value: this.site[element],
          });
        }
      });
      return mappedSite.filter(el => el != null);
    },
  },
  methods: {
    ...mapActions({
      fetchCommonData: 'partners/fetchCommonData',
      fetchSite: 'sites/fetchSite',
      updatesiteParams: 'sites/updateSite',
    }),
    clickUpdateSite() {
      this.fetchSite({
        partnerId: this.loggedInUser.partner_id,
        id: this.site.id,
      })
        .then((site) => {
          this.$eventBus.showModal({
            bind: {
              is: GenericForm,
              title: this.$t('app.sites.edit_site'),
              fields: this.siteAttributes,
              model: site,
              submitTitle: this.$t('app.sites.buttons.save'),
              cancelTitle: this.$t('app.sites.buttons.cancel'),
              modelName: 'sites',
            },
            on: {
              submit: this.updateSite,
            },
          });
        })
        .catch((error) => {
          const mappedErrors = error.map(x => ` ${x}`);
          this.$swal
            .fire({
              html: mappedErrors,
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
    },
    updateSite(payload) {
      this.updatesiteParams(
        {
          partnerId: this.loggedInUser.partner_id,
          params: payload,
        },
      )
        .then((response) => {
          this.site = response;
          this.$eventBus.hideModal();
          this.$eventBus.showNotification({
            notificationText: this.$t('app.sites.success.update'),
            notificationType: 'success',
          });
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
  },
  mounted() { },
  watch: {
  },
};
</script>

<style lang="scss">
.basic-details-screen {
  .card-list {
    margin-bottom: 20px;
  }

  .zmdi-delete {
    margin-left: -40px;
  }

  .panel-heading {
    padding-left: 0;
  }

  .contact-section {
    border-top: 1px solid #F1F1F3;
  }

  .safety-doc-table {

    th,
    td {
      padding-left: 0;
    }
  }

  .card-display {
    .title {
      font-size: 18px;
      font-weight: 500;
    }

    .value {
      font-size: 15px !important;
      color: #43425D;
      opacity: 0.5;
    }
  }

  .button-row {
    margin-top: 5px;
    padding-right: 35px;
    text-align: right;
  }

  .rounded {
    border-radius: 4px;
  }

  .contact-part {
    text-align: right;
    overflow: hidden;
    overflow-y: auto;
  }

  .safety-part {
    margin-top: 30px !important;
  }

  .action-button {
    cursor: pointer;
  }
}

.dialog {
  .dg-btn--ok {
    border-color: green;
  }

  .dg-btn-loader .dg-circle {
    background-color: green;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/modules/partners/SiteScreen.vue